/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Compare_EyebrowInputs */

const en_home_compare_eyebrow = /** @type {(inputs: Home_Compare_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CADCraft vs AutoCAD`)
};

/**
* | output |
* | --- |
* | "CADCraft vs AutoCAD" |
*
* @param {Home_Compare_EyebrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_compare_eyebrow = /** @type {((inputs?: Home_Compare_EyebrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Compare_EyebrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_compare_eyebrow(inputs)
});
export { home_compare_eyebrow as "home.compare.eyebrow" }